import { Outlet } from 'react-router';

import { StaticLoader } from '@enterprise/ui';

import { useSessionRecoveryConfiguration } from './hooks/session-recovery-configuration.hook';

const SessionRecovery = () => {
  const { recovering } = useSessionRecoveryConfiguration();

  if (recovering) {
    return <StaticLoader />;
  }

  return <Outlet />;
};

export default SessionRecovery;
